import './commonAssets';

import '../common/javascripts/modules/member/MemberSubMembers.js';
import '../common/javascripts/modules/signup/JoinStep1BMT.js';
import '../common/javascripts/modules/survey/SurveyRedirect.js';
import '../videoblocks/javascripts/modules/member/VideoMemberCreditCardUpdate.js';

import '../common/stylesheets/maintenance.css';
import '../common/stylesheets/modules/collections/collection-browse.less';
import '../common/stylesheets/modules/collections/collection-template.less';
import '../common/stylesheets/modules/details-uff.less';
import '../common/stylesheets/modules/member-uff.less';
import '../common/stylesheets/modules/signup/bmt-free-trial.less';
import '../common/stylesheets/modules/survey/survey.less';
import '../common/stylesheets/modules/widgets/full-width-background-widget.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design-v2.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget-card-design.less';
import '../common/stylesheets/modules/widgets/stock-item-group-widget.less';
import '../videoblocks/modules/stock/collections/restSpinnerOverlay.less';
import '../videoblocks/stylesheets/components/mixins.less';
import '../videoblocks/stylesheets/modules/details-uff.less';
import '../videoblocks/stylesheets/modules/homepage/homepage.less';
import '../common/stylesheets/modules/hero/hero.less';
import '../videoblocks/stylesheets/modules/member/custom-mixins.less';
import '../videoblocks/stylesheets/modules/search/tabbed-search.less';


import AppLoader from '../react/AppLoader/AppLoader';

import PopUpsContainer from '../react/PopUps/PopUpsContainer';
import ReactToastifyContainer from '../react/ReactToastify/containers/ReactToastifyContainer';
import NPSModalLoaderContainer from '../react/NPSModalLoader/NPSModalLoaderContainer';
import StockItemCollectionContainer from '../react/app/Search/containers/StockItemCollectionContainer';
import VideoSiteConstants from '../react/common/SiteConstants/VideoSiteConstants';
import EntTrialBanner from "../react/Trials/EntTrialBanner";
import AudioContainer from "../react/Audio/containers/AudioContainer";
import NavApps from "../react/app/NavApps";

AppLoader.load({
  routes: [
    {
      name: 'Collection',
      path: new VideoSiteConstants().getCollectionsRoute(),
      component: StockItemCollectionContainer,
    },
  ],
  auxApps: {
    ...NavApps,
    'audio-app': AudioContainer,
    'pop-up-container': PopUpsContainer, // FIXME: causes missing matching <div> in <section>
    'nps-modal': NPSModalLoaderContainer,
    'react-toastify-container': ReactToastifyContainer, // FIXME: causes missing matching <div> in <section>,
  },
  propBasedApps: {
    'entTrialBanner': EntTrialBanner
  },
});
